import React, { Component } from "react";
import { connect } from "react-redux";
import { BsSearch } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import Footer from "../Footer";
import ContentLoader from "react-content-loader";
import { getParentChatList } from "../../../redux/Parent/chat/action";
import { ChatList } from "./ChatList/index";
import Axios from "axios";
import { Modal } from "react-bootstrap";
import { WEBSITE_URL, IMAGE_BASE_URL } from "../../../api";
import teacherImg from "../../../assets/Images/bg.png";

export class Chat extends Component {
    state = {
        loading: false,
        showModal: false,
        teachers: [],
        loadingTeachers: false,
        searchQuery: "",
    };

    componentDidMount() {
        this.setState({ loading: true });
        let student_id = null;
        try {
            student_id = JSON.parse(localStorage.getItem("student_id"));
        } catch (e) {}

        const { user } = this.props;
        if (user?.data?.auth_token) {
            this.props.getParentChatList(user.data.auth_token, student_id?.value);
        }
        setTimeout(() => {
            this.setState({ loading: false });
        }, 1200);
    }

    fetchTeachers = () => {
        const { user } = this.props;
        let student_id = null;
        try {
            student_id = JSON.parse(localStorage.getItem("student_id"));
        } catch (e) {}

        const token = user?.data?.auth_token;
        const studentVal = student_id?.value;

        this.setState({ loadingTeachers: true, showModal: true });
        Axios.post(WEBSITE_URL + "/get-teachers-for-parent", { token, student_id: studentVal })
            .then((res) => {
                if (res.data && res.data.success) {
                    this.setState({ teachers: res.data.data || [], loadingTeachers: false });
                } else {
                    this.setState({ loadingTeachers: false });
                }
            })
            .catch(() => {
                this.setState({ loadingTeachers: false });
            });
    };

    render() {
        const { user, chat } = this.props;
        const parentId = user?.data?.id || 1;

        const filteredTeachers = this.state.teachers.filter((t) => {
            const name = t?.user?.name || t?.first_name || t?.name || "";
            return name.toLowerCase().includes(this.state.searchQuery.toLowerCase());
        });

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <React.Fragment>
                        <ContentLoader
                            viewBox="0 0 280 550"
                            backgroundColor={"#F3F3F3"}
                            foregroundColor={"#FFFFFF"}
                        >
                            <rect
                                x="8"
                                y="18"
                                rx="8"
                                ry="8"
                                width="25"
                                height="29"
                            />
                            <rect
                                x="245"
                                y="18"
                                rx="8"
                                ry="8"
                                width="25"
                                height="29"
                            />
                            <rect
                                x="8"
                                y="67"
                                rx="5"
                                ry="5"
                                width="80"
                                height="20"
                            />
                            <rect
                                x="8"
                                y="100"
                                rx="5"
                                ry="5"
                                width="50"
                                height="10"
                            />
                            <rect
                                x="8"
                                y="130"
                                rx="5"
                                ry="5"
                                width="57"
                                height="22"
                            />
                            <rect
                                x="80"
                                y="130"
                                rx="5"
                                ry="5"
                                width="45"
                                height="22"
                            />
                            <rect
                                x="15"
                                y="180"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="185"
                                rx="5"
                                ry="5"
                                width="40"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="205"
                                rx="5"
                                ry="5"
                                width="30"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="240"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="240"
                                rx="5"
                                ry="5"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="265"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="300"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="300"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />

                            <rect
                                x="70"
                                y="330"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="365"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="365"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="390"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="430"
                                rx="10"
                                ry="10"
                                width="40"
                                height="40"
                            />
                            <rect
                                x="70"
                                y="430"
                                rx="10"
                                ry="10"
                                width="45"
                                height="15"
                            />
                            <rect
                                x="70"
                                y="460"
                                rx="5"
                                ry="5"
                                width="65"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="525"
                                rx="12"
                                ry="12"
                                width="250"
                                height="35"
                            />
                        </ContentLoader>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center px-3 py-4">
                                <div onClick={this.fetchTeachers} style={{ cursor: "pointer" }}>
                                    <BsSearch style={{ fontSize: "18px" }} />
                                </div>
                                <div onClick={this.fetchTeachers} style={{ cursor: "pointer" }}>
                                    <AiOutlinePlus style={{ fontSize: "22px", color: "#0D6EFD" }} />
                                </div>
                            </div>
                            <div className="px-3">
                                <span
                                    style={{
                                        color: "#212529",
                                        fontWeight: "300",
                                        fontSize: "22px",
                                    }}
                                >
                                  Chat With Teachers
                                </span>
                            </div>
                            {chat && chat.success && (
                                <div className="px-3">
                                    <span
                                        style={{
                                            color: "#ADB5BD",
                                            fontWeight: "400",
                                            fontSize: "10px",
                                        }}
                                    >
                                        {chat?.chat_list?.length || 0} Teachers
                                    </span>
                                </div>
                            )}
                            <ChatList chat={chat}
                                user={user}
                            />
                            <div>
                                <Footer current={"message"} />
                            </div>
                        </div>

                        {/* New Chat Modal for Teachers */}
                        <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })} centered>
                            <Modal.Header closeButton>
                                <Modal.Title style={{ fontSize: "16px", fontWeight: "600" }}>Start New Chat with Teacher</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                <input
                                    type="text"
                                    className="form-control mb-3"
                                    placeholder="Search teacher by name..."
                                    value={this.state.searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                />
                                {this.state.loadingTeachers ? (
                                    <div className="text-center py-3 text-muted">Loading teachers...</div>
                                ) : filteredTeachers.length > 0 ? (
                                    filteredTeachers.map((t) => {
                                        const name = t?.user?.name || `${t?.first_name || ''} ${t?.last_name || ''}`.trim() || 'Teacher';
                                        const imgUrl = t?.user?.image || t?.image;

                                        return (
                                            <div
                                                key={t.id}
                                                className="d-flex align-items-center justify-content-between p-2 border-bottom"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    this.setState({ showModal: false });
                                                    this.props.history.push(`/single-chat/${parentId}/${t.id}`);
                                                }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={imgUrl ? IMAGE_BASE_URL + imgUrl : teacherImg}
                                                        alt={name}
                                                        style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                                                    />
                                                    <div className="ms-3">
                                                        <div className="fw-bold" style={{ fontSize: "14px", color: "#333" }}>{name}</div>
                                                        <div className="text-muted" style={{ fontSize: "12px" }}>{t?.user?.email || 'Teacher'}</div>
                                                    </div>
                                                </div>
                                                <button className="btn btn-sm btn-primary px-3" style={{ borderRadius: "6px" }}>Chat</button>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center py-3 text-muted">No teachers found</div>
                                )}
                            </Modal.Body>
                        </Modal>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user.parent,
    chat: state.chat.chat_list,
});

export default connect(mapStateToProps, {
    getParentChatList,
})(Chat);
